module.exports = __webpack_public_path__ + "static/media/g-icon-add-black.2ffd6523.svg";